import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

export default function AlertBar( { showAlert , severity="success" , alertMessage="" } ) {
  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  
  return (
    <>
      {/* <Stack sx={{ width: '100%' , mt: 2}} spacing={2}> */}
      <Snackbar
        open={true}
        autoHideDuration={6000}
        onClose={handleClose}
        sx={{pt:7 , zIndex: 99999}}
       >
        <Alert 
        severity={severity} 
        sx={{ p:3}} 
        variant="filled"
        >
          <AlertTitle>{severity.toUpperCase()}</AlertTitle>
          <div dangerouslySetInnerHTML={{ __html: alertMessage }} />
        </Alert>
      </Snackbar>
      {/* </Stack> */}
    </>


  );
}